'use client';

import { useState, ReactNode } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

type Props = {
    text: string | ReactNode;
    collapsedMaxHeight?: string;  
    bg?: string;
    className?: string;
};

export default function CollapsibleText({
    text,
    collapsedMaxHeight = '3.5em',
    bg = '#fff',
    className,
}: Props) {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <div className="relative">
            <div
                className={`${
                    className ?? ''
                } relative overflow-hidden transition-[max-height] duration-500 ease-in-out`}
                style={{
                    maxHeight: isExpanded ? '4500px' : collapsedMaxHeight,
                }}
            >
                <div className="text-sm text-[#222222D6]  text-justify">
                    {text}
                </div>

                {!isExpanded && (
                    <div
                        style={{
                            backgroundImage: `linear-gradient(to top, ${bg}, transparent)`,
                        }}
                        className="absolute bottom-0 left-0 w-full h-8 pointer-events-none"
                    />
                )}
            </div>

            <div className="w-full flex justify-center mt-2">
                <button
                    name="chevron-texts"
                    className="bg-white text-gray-600 rounded-full shadow px-2 py-1 z-0"
                    onClick={() => setIsExpanded((prev) => !prev)}
                >
                    {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
                </button>
            </div>
        </div>
    );
}
